<template>
  <Dialog
    v-model="useDialogStore().planCreate.isOpen"
    size="small-hug"
    @open="onOpen"
    @close="onClose"
  >
    <template #header="{ close }">
      <DialogHeader
        :title="useT('bcd271')"
        :show-close="true"
        @close="close"
      />
    </template>

    <div
      v-if="isLoading"
      v-loading="true"
      class="h-80 w-full"
    />
    <div v-else>
      <Form
        ref="formRef"
        :model="form"
        :rules="rules"
        @submit="onSubmit"
      >
        <InputBlock
          :label="useT('bcd264')"
          prop="type"
        >
          <RadioGroup
            :model-value="form.type"
            :options="[
              { id: 'singleUse', text: useT('bcd245') },
              { id: 'subscription', text: useT('bcd246' ) },
            ]"
            @update:model-value="onTypeChange"
          />
        </InputBlock>

        <InputBlock
          :label="useT('bcd249')"
          prop="config.tier"
          direction="horizontal"
        >
          <Select
            :model-value="form.config?.tier"
            :options="[
              { id: 'basic', text: useT('bcd250') },
              { id: 'professional', text: useT('bcd251') },
              { id: 'enterprise', text: useT('bcd252') },
            ]"
            @update:model-value="(value) => _set(form, 'config.tier', value)"
          />
        </InputBlock>

        <InputBlock
          :label="useT('bcd266')"
          prop="config.maxCapacity"
          direction="horizontal"
        >
          <NumberInput
            :model-value="form.config?.maxCapacity"
            class="w-full"
            :min="0"
            @update:model-value="(value) => _set(form, 'config.maxCapacity', value)"
          />
        </InputBlock>

        <template v-if="form.type === 'subscription'">
          <InputBlock
            :label="useT('bcd254')"
            prop="config.billingPeriod"
            direction="horizontal"
          >
            <Select
              :model-value="form.config?.billingPeriod"
              :options="[
                { id: 'monthly', text: useT('bcd255') },
                { id: 'annual', text: useT('bcd256') },
              ]"
              @update:model-value="(value) => _set(form, 'config.billingPeriod', value)"
            />
          </InputBlock>

          <InputBlock
            :label="useT('bcd295')"
            prop="config.expiringAt"
            direction="horizontal"
          >
            <DatePicker
              v-model="form.config.expiringAt"
              class="w-full"
            />
          </InputBlock>
        </template>
      </Form>
    </div>

    <template
      v-if="!isLoading"
      #footer
    >
      <ButtonGroup
        type="primary"
        :text-submit="useT('bcd272')"
        :text-cancel="useT('bcd205')"
        align="right"
        :loading="isSubmitting"
        @submit="formRef.onSubmit()"
        @cancel="useDialogStore().close('planCreate')"
      />
    </template>
  </Dialog>
</template>

<script setup>
// Refs
const defaultForm = () => ({
  type: 'singleUse',
  config: {
    tier: 'professional',
    maxCapacity: 200,
  },
});

const form = ref(defaultForm());

const rules = {
};

const isLoading = ref(false);
const isSubmitting = ref(false);
const formRef = ref(null);

// Computed

// Methods
const onTypeChange = (value) => {
  _set(form.value, 'type', value);

  if (value === 'subscription') {
    _set(form.value, 'config.billingPeriod', form.value.config?.billingPeriod || 'annual');
    _set(form.value, 'config.expiringAt', form.value.config?.expiringAt || dayjs().add(1, 'year').toDate());
  } else {
    _set(form.value, 'config.billingPeriod', null);
    _set(form.value, 'config.expiringAt', null);
  }
};

const onOpen = async() => {
  form.value = defaultForm();
};

const onClose = () => {
  form.value = defaultForm();
};

const savePlan = async() => {
  isSubmitting.value = true;

  const response = await usePlansStore().create({
    ...form.value,
    workspace: useDialogStore().planCreate.workspaceDomain,
  });

  isSubmitting.value = false;

  if (response) {
    useToast(useT('bcd138'));
    useDialogStore().planCreate.onSubmit(response);
  }

  return response;
};

const onSubmit = async() => {
  const response = await savePlan();
  if (response) {
    useDialogStore().close('planCreate');
  }
};
</script>
